export const setPatternValidation = (v, f) => {
    if (f.pattern) {
        return v.matches(f.pattern, "Invalid pattern!");
    }
    return v;
};